export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70655fbd4d889efa338a0a4c407ca54afe871c6969&name=pushAdClickData!'